export default __webpack_public_path__ + "static/media/m2.129ffb0e.svg";